<template>
  <v-dialog v-model="mostrar" max-width="500px" persistent>
    <v-card :loading="loading">
      <v-toolbar
        color="blue-grey darken-1"
        dense
        dark
        flat
        class="text-h5"
        height="60px"
      >
        Modificar de/para
      </v-toolbar>

      <v-container style="margin-top: 15px">
        <v-row>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-text-field
              v-model="deLocal"
              label="De"
              outlined
              dense
              :error-messages="error.deLocal"
              @input="validarDe()"
              @blur="validarDe()"
            />
          </v-col>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-text-field
              v-model="paraLocal"
              label="Para:"
              outlined
              dense
              :error-messages="error.paraLocal"
              @input="validarPara()"
              @blur="validarPara()"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-text-field
              v-model="statusLocal"
              label="Status"
              outlined
              dense
              :error-messages="error.statusLocal"
              @input="validarStatus()"
              @blur="validarStatus()"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-menu
              v-model="fechaPicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Fecha:"
                  :value="fechaTexto"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaLocal"
                locale="es"
                @change="fechaPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-text-field
              v-model="asuntoLocal"
              label="Asunto:"
              outlined
              dense
              :error-messages="error.asuntoLocal"
              @input="validarAsunto()"
              @blur="validarAsunto()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="mx-3"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue-grey darken-1"
          :disabled="loading"
          outlined
          small
          @click="$emit('cancelar')"
          >Cancelar</v-btn
        >
        <v-btn
          color="blue-grey darken-1"
          :loading="loading"
          :class="{
            'disable-events':
              error.deLocal.length > 0 ||
              deLocal.length === 0 ||
              error.paraLocal.length > 0 ||
              paraLocal.length === 0 ||
              error.asuntoLocal.length > 0 ||
              asuntoLocal.length === 0 ||
              error.statusLocal.length > 0 ||
              statusLocal.length === 0
          }"
          dark
          small
          @click="guardarDepara()"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {DateTime,Settings} from 'luxon';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { modificarOficioDeparaService } from "./depara.service";

Settings.defaultLocale = 'es';

export default {
  name: "modificarDepara",
  mixins: [validationMixin],
  props: ["mostrar", "depara"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId", "userNameComplete"]),
    fechaTexto() {
      return this.fechaLocal
        ? this.fechaLocal ? DateTime.fromFormat(this.fechaLocal, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy")  : ''
        : "";

        
    },
  },
  validations: {
    deLocal: { required },
    paraLocal: { required },
    asuntoLocal: { required },
    statusLocal: { required },
  },
  data: () => ({
    loading: false,
    deLocal: "",
    paraLocal: "",
    fechaLocal: DateTime.now().setZone('America/Mazatlan').toFormat('yyyy-MM-dd'),
    fechaPicker: false,
    statusLocal: "",
    asuntoLocal: "",
    error: {
      deLocal: [],
      paraLocal: [],
      asuntoLocal: [],
      statusLocal: [],
    },
  }),
  mounted() {
    this.deLocal = this.depara.de;
    this.paraLocal = this.depara.para;
    this.fechaLocal = DateTime.fromSQL(this.depara.fecha.split('T')[0]).toFormat('yyyy-MM-dd')
    this.statusLocal = this.depara.status;
    this.asuntoLocal = this.depara.asunto;
  },
  methods: {
    validarDe() {
      this.$v.deLocal.$touch();
      const errors = [];
      if (this.$v.deLocal.$dirty) {
        !this.$v.deLocal.required && errors.push("Campo requerido.");
      }
      this.error.deLocal = errors;
    },
    validarPara() {
      this.$v.paraLocal.$touch();
      const errors = [];
      if (this.$v.paraLocal.$dirty) {
        !this.$v.paraLocal.required && errors.push("Campo requerido.");
      }
      this.error.paraLocal = errors;
    },
    validarStatus() {
      this.$v.statusLocal.$touch();
      const errors = [];
      if (this.$v.statusLocal.$dirty) {
        !this.$v.statusLocal.required && errors.push("Campo requerido.");
      }
      this.error.statusLocal = errors;
    },
    validarAsunto() {
      this.$v.asuntoLocal.$touch();
      const errors = [];
      if (this.$v.asuntoLocal.$dirty) {
        !this.$v.asuntoLocal.required && errors.push("Campo requerido.");
      }
      this.error.asuntoLocal = errors;
    },
    async guardarDepara() {
      try {
        this.loading = true;

        const data = {
          idDepara: this.depara._id,
          de: this.deLocal,
          para: this.paraLocal,
          fecha: this.fechaLocal,
          status: this.statusLocal,
          asunto: this.asuntoLocal,
        };

        const serverResponse = await modificarOficioDeparaService(data);
        this.loading = false;
        if (!serverResponse.ok)
          this.$systemErrorMessage(serverResponse.mensaje);
        else {
          this.loading = false;
          this.$notify({
            group: "gral_notif",
            type: "success",
            duration: 1500,
            speed: 500,
            text: serverResponse.mensaje,
          });
          this.$emit("deparaModificado", serverResponse.depara);
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
    },
  },
};
</script>

<style>
.disable-events {
  pointer-events: none;
  opacity: 0.2;
}
</style>